export default "__VITE_ASSET__BzaIoZQN__"